import { render, staticRenderFns } from "./VariantUrlsPopup.vue?vue&type=template&id=3c971524&scoped=true&"
import script from "./VariantUrlsPopup.vue?vue&type=script&lang=js&"
export * from "./VariantUrlsPopup.vue?vue&type=script&lang=js&"
import style0 from "./VariantUrlsPopup.vue?vue&type=style&index=0&id=3c971524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c971524",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
